"use client";
import React, { createContext, useContext } from "react";
import { useCurrentLocale } from "@/app/lib/LocaleProvider";

interface CommonParamsType {
  countryCode: string;
  lng: string;
}

const CommonParamsContext = createContext<CommonParamsType>({
  countryCode: "",
  lng: "",
});

export function CommonParamsProvide({
  children,
}: {
  children: React.ReactNode;
}) {
  const locale = useCurrentLocale();
  const countryCode = locale === "zh-CN" ? "CN" : "US";
  const value: CommonParamsType = { countryCode, lng: locale };

  return (
    <CommonParamsContext.Provider value={value}>
      {children}
    </CommonParamsContext.Provider>
  );
}

export { CommonParamsContext };
